<template>
  <div id="app">
    <meta http-equiv="cache-control" content="no-cache" />
    <router-view/>
  </div>
</template>

<style>
  @import "vue-select/dist/vue-select.css";
  #app {
    display: flex;
    flex-direction: column;
    font-family: Arial, 'Avenir', Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100%;
    height: 100%;
  }

</style>

<script>

  export default {
    name: "app",
    created: function() {
      this.$store.dispatch('authentication/configureHttpClient');
    }
  }

</script>

<script setup>
  import Intercom from '@intercom/messenger-js-sdk';

  Intercom({
    app_id: 'vk7z3ch7',
    region: 'eu'
  });
</script>

